export const PAIRS_CONNECTED_BOTS_SLICE = 'pairs-connected-bots';
export const SET_CONNECTED_BOTS_ACTION = `${PAIRS_CONNECTED_BOTS_SLICE}/setConnectedBots`;
